export default function MailIconUIKit({ width = 20, height = 20, stroke = 'currentColor', strokeWidth = 1 }) {
	return <svg width={width} height={height} viewBox="0 0 20 20">
		<polyline
			fill="none"
			stroke={stroke}
			strokeWidth={strokeWidth}
			points="1.4,6.5 10,11 18.6,6.5"
		/>
		<path
			fill="none"
			stroke={stroke}
			strokeWidth={strokeWidth}
			d="M 1,4 1,16 19,16 19,4 1,4 Z M 18,15 2,15 2,5 18,5 18,15 Z"
		/>
	</svg>
};
